import { palette, updatePreset } from "@primeuix/themes";

const PRIMARY_COLOR = "primary-color";
const APP_BACKGROUND_COLOR = "app-background-color";

const HEX_PATTERN = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

interface ThemeEntry {
    cssPropertyName: string;
    cssPropertyValue: string;
}

export function applyBrandTheme(themes: ThemeEntry[]): void {
    const primary = themes.find((theme) => theme.cssPropertyName === PRIMARY_COLOR)?.cssPropertyValue;
    const appBackground = themes.find((theme) => theme.cssPropertyName === APP_BACKGROUND_COLOR)?.cssPropertyValue;

    const semantic = {
        ...(primary && HEX_PATTERN.test(primary) ? { primary: palette(primary) } : {}),
        ...(appBackground ? { extend: { appBackground } } : {})
    };

    if (Object.keys(semantic).length > 0) updatePreset({ semantic });
}
